import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatDropdown = createCustomElementWrapper('kat-dropdown', 'KatDropdown', {
    'constraintEmphasis': 'constraint-emphasis',
    'constraintLabel': 'constraint-label',
    'katAriaLabel': 'kat-aria-label',
    'maxHeight': 'max-height',
    'mobileLabel': 'mobile-label',
    'multipleHideSelect': 'multiple-hide-select',
    'multipleShowApply': 'multiple-show-apply',
    'multipleStickyApply': 'multiple-sticky-apply',
    'richSelectionLabel': 'rich-selection-label',
    'showClear': 'show-clear',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
    'tooltipPosition': 'tooltip-position',
    'tooltipText': 'tooltip-text',
    'tooltipTriggerIcon': 'tooltip-trigger-icon',
}, {
    'onChange': 'change',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/dropdown.js
// module id = 1248
// module chunks = 0